__turbopack_context__.v({
  "actionBtn": "TypeSelector-module__w-5U7q__actionBtn",
  "active": "TypeSelector-module__w-5U7q__active",
  "addBtn": "TypeSelector-module__w-5U7q__addBtn",
  "arrowContainer": "TypeSelector-module__w-5U7q__arrowContainer",
  "container": "TypeSelector-module__w-5U7q__container",
  "footer": "TypeSelector-module__w-5U7q__footer",
  "input": "TypeSelector-module__w-5U7q__input",
  "item": "TypeSelector-module__w-5U7q__item",
  "itemActions": "TypeSelector-module__w-5U7q__itemActions",
  "itemLabel": "TypeSelector-module__w-5U7q__itemLabel",
  "list": "TypeSelector-module__w-5U7q__list",
  "popIn": "TypeSelector-module__w-5U7q__popIn",
  "popoverContent": "TypeSelector-module__w-5U7q__popoverContent",
  "trigger": "TypeSelector-module__w-5U7q__trigger",
  "typeClosing": "TypeSelector-module__w-5U7q__typeClosing",
  "typeDemo": "TypeSelector-module__w-5U7q__typeDemo",
  "typeDiscovery": "TypeSelector-module__w-5U7q__typeDiscovery",
  "typeInterview": "TypeSelector-module__w-5U7q__typeInterview",
  "typeOther": "TypeSelector-module__w-5U7q__typeOther",
  "value": "TypeSelector-module__w-5U7q__value",
});
